<template>
  <div class="container" style="width: 100%;padding: 16px;">
    <span style="color:red">手机端粘贴按钮可能不行!!建议不依靠按钮</span>

    <Form>
      <FormItem label="当前密钥状态">
        <div v-html="authdescript" style="font-weight: bolder;"></div>
      </FormItem>
      <FormItem label="系统密匙">
        <Button style="float:right" size="small" type="info" @click="clip">粘贴</Button>
        <Input v-model="srcVal" :rows="8" type="textarea" ref="src1" />
      </FormItem>
      <FormItem label="授权到期时间">
        <DatePicker type="date" placeholder="选择到期日期" style="width:'400px'" v-model="expiredt"></DatePicker>

      </FormItem>
      <FormItem>
        <div>
          <Button size="small" type="info" @click="add(1)">+1个月</Button>
          <Button size="small" type="info" @click="add(2)">+2个月</Button>
          <Button size="small" type="info" @click="add(5)">+5个月</Button>
          <Button size="small" type="info" @click="add(12)">+12个月</Button>
          <Button size="small" type="info" @click="add(12*999)">+999年</Button>
        </div>
        <div>
          <Button size="small" type="warning" @click="add(-1)">-1个月</Button>
          <Button size="small" type="warning" @click="add(-2)">-2个月</Button>
          <Button size="small" type="warning" @click="add(-5)">-5个月</Button>
          <Button size="small" type="warning" @click="add(-12)">-12个月</Button>
          <Button size="small" type="warning" @click="add(-12*999)">-999年</Button>
        </div>
      </FormItem>
      <FormItem label="授权licenese">
        <Button class="genlic_copybtn" style="float:right" size="small" type="info" v-if="isSupported">复制</Button>

        <Input v-model="licVal" :rows="8" type="textarea" />
      </FormItem>
      <FormItem>

        <div style="display:flex;justify-content: space-between;margin:8px 0px">
          <Button type="primary" style="flex: 1;" @click="starauth">生成License</Button>
          <div style="width:8px"></div>
          <Button type="warning" style="flex: 1;" @click="download">下载文件</Button>
        </div>
      </FormItem>
    </Form>
  </div>
</template>
<script>
function copytext(text) {
  if (navigator.clipboard) {
    // clipboard api 复制
    navigator.clipboard.writeText(text)
  } else {
    var textarea = document.createElement("textarea")
    document.body.appendChild(textarea)
    // 隐藏此输入框
    textarea.style.position = "fixed"
    textarea.style.clip = "rect(0 0 0 0)"
    textarea.style.top = "10px"
    // 赋值
    textarea.value = text
    // 选中
    textarea.select()
    // 复制
    document.execCommand("copy", true)
    // 移除输入框
    document.body.removeChild(textarea)
  }
}

function frombase64(rawStr) {
  var parsedWordArray = CryptoJS.enc.Base64.parse(rawStr)
  var parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8)
  return parsedStr
}

export default {
  data() {
    let isSupported = window.Clipboard.isSupported()

    return {
      isSupported,
      srcVal: "",
      licVal: "",
      expiredt: new Date(),
    }
  },
  computed: {
    authdescript() {
      let descript = ""
      try {
        let authinfo = JSON.parse(frombase64(this.srcVal))

        if (authinfo.authleftdays == undefined) {
          descript = "<span style='color:red'>无授权</span>"
          this.expiredt = new Date()
        } else if (authinfo.authleftdays < 0) {
          descript = `<span style='color:red'>[${authinfo.appname}]已过期${authinfo.authleftdays}天</span>`
        } else {
          descript = `<span style='color:green'>[${authinfo.appname}]剩余${authinfo.authleftdays}天过期</span>`

          this.expiredt = new Date(authinfo.expired)
        }
      } catch (error) {
        descript = "无法识别的密钥"
      }

      return descript
    },
  },
  methods: {
    add(month) {
      this.expiredt = moment(this.expiredt).add(month, "months").toDate()
    },

    clip() {
      navigator.clipboard.readText().then((c) => {
        this.srcVal = c.toString()
        this.$toast.success("粘贴完成")
      })
    },
    copy(e) {
      copytext(this.licVal)
      this.$toast.success("复制完成")
    },
    starauth() {
      let authinfo = JSON.parse(frombase64(this.srcVal))
      authinfo.expired = this.expiredt.getTime()
      delete authinfo["authleftdays"]
      this.$app.http
        .post("core.auth.genAuth", {
          authinfo,
        })
        .then((res) => {
          this.licVal = res.toString()
        })
    },
    download(){
      if (this.licVal) {
        this.$app.helper.file.fileSaver(new Blob([this.licVal], { type: "text/plain;charset=utf-8" }), "lic.txt")
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.clipboard = new window.Clipboard(".genlic_copybtn", {
        target: function (trigger) {
          return trigger.nextElementSibling
        },
      })
    })
  },
  destroyed() {
    if (this.clipboard) this.clipboard.destroy()
  },
}
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
  .ivu-form-item {
    margin: 0 !important;
  }
}
</style>